import { render } from "./CreateAttributeValueModal.vue?vue&type=template&id=78d005cd"
import script from "./CreateAttributeValueModal.vue?vue&type=script&lang=js"
export * from "./CreateAttributeValueModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__